import { SET_APEX_USER_CHECKED } from './constants';

function loginReducer(state = {}, action) {
  switch (action.type) {
    case SET_APEX_USER_CHECKED:
      return { ...state, isApexUserChecked: action.params.apexUser };
    default:
      return state;
  }
}

export default loginReducer;



// WEBPACK FOOTER //
// ./src/containers/Login/reducer.js